export default function ownerDocument(node) {
  return node && node.ownerDocument || document;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
// module id = 32
// module chunks = 74